// Mock data for KST Spice Corner (frontend-only phase)

export const logo = '/logo.png';

export const grandOpeningPoster =
  'https://customer-assets.emergentagent.com/job_flavor-gallery-15/artifacts/y20frn48_WhatsApp%20Image%202026-07-09%20at%205.32.46%20PM.jpeg';

export const sinthiaBanner =
  'https://customer-assets.emergentagent.com/job_flavor-gallery-15/artifacts/9jyqqdiq_sinthia.jpg';

export const packingMachine = 'https://images.unsplash.com/photo-1717386255767-52643970d483';

// Sinthia own-brand story
export const sinthiaBrand = {
  tagline: 'Curated Spices & Grains \u2014 Sourced Worldwide, Delivered Australia-Wide',
  slogan: 'The Better Choice',
  paragraph:
    "Sinthia is our own signature label, built on genuine global sourcing. We procure our spices, grains, and pulses directly from their countries of origin \u2014 hand-selecting the finest harvests at the source to guarantee unmatched authenticity, aroma, and freshness in every single pack.",
  paragraph2:
    "Everything is then cleaned, quality-checked, and packed in our own modern facility before being distributed to homes, retailers, and wholesalers right across Australia. From origin to your kitchen, Sinthia gives you the honest, home-cooked flavour of India and Sri Lanka \u2014 pure ingredients, packed with care, and trusted nationwide.",
  highlights: [
    'Procured directly from countries of origin',
    'Modern in-house packing facility',
    'Distributed Australia-wide',
    'No artificial colours or additives',
  ],
};

export const sinthiaProducts = [
  { id: 'idly-rice', name: 'Thanjavur Idly Rice', weight: '5 kg', image: '/products/idly-rice.png', note: 'Soft, fluffy idlis every time' },
  { id: 'moong-beans', name: 'Sinthia Moong Beans', weight: '1 kg', image: '/products/moong-beans.png', note: 'Whole green mung, protein-rich' },
  { id: 'desi-chick-peas', name: 'Sinthia Desi Chick Peas', weight: '1 kg', image: '/products/desi-chick-peas.png', note: 'Traditional kala chana' },
  { id: 'chick-peas', name: 'Sinthia Chick Peas (Small)', weight: '1 kg', image: '/products/chick-peas.png', note: 'Perfect for curries & chana' },
  { id: 'moong-dhal', name: 'Sinthia Moong Dhal', weight: '1 kg', image: '/products/moong-dhal.png', note: 'Split yellow moong, quick-cooking' },
  { id: 'samba-rice', name: 'Samba Rice', weight: '5 kg', image: '/products/samba-rice.png', note: 'Authentic Sri Lankan staple' },
];

export const images = {
  spices1: 'https://images.unsplash.com/photo-1525289722380-f5bf1653d504',
  spices2: 'https://images.pexels.com/photos/30296301/pexels-photo-30296301.jpeg',
  spices3: 'https://images.pexels.com/photos/28411491/pexels-photo-28411491.jpeg',
  spices4: 'https://images.unsplash.com/flagged/photo-1553617569-8ef7a8da3146',
  spices5: 'https://images.unsplash.com/photo-1529517986296-847580704921',
  produce: 'https://images.pexels.com/photos/37321079/pexels-photo-37321079.jpeg',
  rice: 'https://images.pexels.com/photos/36346840/pexels-photo-36346840.jpeg',
  market: 'https://images.pexels.com/photos/19227962/pexels-photo-19227962.jpeg',
  marketStall: 'https://images.pexels.com/photos/5336705/pexels-photo-5336705.jpeg',
  spiceDisplay: 'https://images.pexels.com/photos/31805563/pexels-photo-31805563.jpeg',
  sweets: 'https://images.pexels.com/photos/36236282/pexels-photo-36236282.jpeg',
  laddu: 'https://images.pexels.com/photos/34153206/pexels-photo-34153206.jpeg',
  storeInterior: 'https://images.unsplash.com/photo-1515706886582-54c73c5eaf41',
  cardamom: 'https://images.pexels.com/photos/6086300/pexels-photo-6086300.jpeg',
  turmeric: 'https://images.pexels.com/photos/6104651/pexels-photo-6104651.jpeg',
  colorfulSpices: 'https://images.pexels.com/photos/877220/pexels-photo-877220.jpeg',
  spiceBowls: 'https://images.pexels.com/photos/32281630/pexels-photo-32281630.jpeg',
  vibrantRice: 'https://images.pexels.com/photos/30756211/pexels-photo-30756211.jpeg',
};

// Countdown target: Trisha / Grand Opening - Sat 18 July 2026, 12:00 PM (Sydney AEST)
export const eventCountdownTarget = '2026-07-18T12:00:00+10:00';

// Home hero slideshow (editable). type: 'poster' only now
export const heroSlides = [
  {
    id: 0,
    type: 'poster',
    image: grandOpeningPoster,
    eyebrow: 'CELEBRATING 15 YEARS',
    titleGold: 'Grand Opening \u2014 Marsden Park Store',
    countdownLabel: 'Ms. Trisha is coming in',
    primary: { label: 'View Event Details', to: '/#grand-opening' },
    secondary: { label: 'Visit Our Stores', to: '/stores' },
  },
];

// Grand opening event details (from poster / Instagram announcement)
export const grandOpening = {
  title: 'The Grand Opening',
  subtitle: 'of our Marsden Park Store',
  anniversary: 'Celebrating 15 Years of KST Spice Corner',
  guest: 'Ms. Trisha',
  guestRole: 'Celebrity Guest',
  date: 'Saturday, 18 July 2026',
  time: '12:00 PM',
  venue: 'Blacktown Showground, Francis Park, Richmond Rd, Blacktown NSW',
  storeAddress: '861 Richmond Rd, Marsden Park NSW 2765',
  tagline: '15 Years of Trust, A New Chapter Begins!',
  organiser: 'Just Grow Productions',
};

export const brands = [
  {
    id: 'sinthia',
    tag: 'OWN BRAND',
    name: 'Sinthia Premium Signature Lines',
    description:
      'Pure, single-origin ground spices, authentic formulas, and specialty grocery assets engineered to preserve real organic profiles.',
    image: images.spices2,
  },
  {
    id: 'kst-spices',
    tag: 'HOME BRAND',
    name: 'KST Spices Collection',
    description:
      'Aromatic wholesale selections, whole herbs, blended traditional seasonings, and everyday culinary additions.',
    image: 'https://customer-assets.emergentagent.com/job_flavor-gallery-15/artifacts/uad8i7wp_image.png',
  },
  {
    id: 'grains',
    tag: 'HOUSE SELECTION',
    name: 'Premium Basmati & Heritage Rice',
    description:
      'Naturally aged basmati alongside prized traditional South Indian & Sri Lankan heritage rice varieties, delivering authentic aroma, texture, and nutrition to every plate.',
    image: images.vibrantRice,
  },
  {
    id: 'produce',
    tag: 'FRESH ARRIVALS',
    name: 'Hand-Selected Vegetables',
    description:
      'Crisp, direct farm-to-table vegetables arriving daily in deep logistics cooling runs to retain absolute freshness.',
    image: images.produce,
  },
];

export const categories = [
  { name: 'Aromatic Spices', image: images.colorfulSpices, count: '120+ varieties' },
  { name: 'Green Cardamom', image: images.cardamom, count: 'Fresh whole pods' },
  { name: 'Turmeric & Powders', image: images.turmeric, count: 'Vibrant & pure' },
  { name: 'Heritage & Basmati Rice', image: images.vibrantRice, count: '25+ grades' },
  { name: 'Fresh Produce', image: images.produce, count: 'Daily fresh' },
  { name: 'Lentils & Pulses', image: images.spices5, count: '40+ types' },
  { name: 'Traditional Sweets', image: images.sweets, count: 'Freshly made' },
  { name: 'Snacks & Namkeen', image: images.laddu, count: '80+ options' },
];

export const values = [
  { title: 'Direct Estate Imports', desc: 'Sourced directly from subcontinental estates for unbeatable authenticity.' },
  { title: 'Strictly Organic Controls', desc: 'Rigorous quality checks keep every product pure and natural.' },
  { title: 'Advanced Cold Chains', desc: 'Deep cooling logistics preserve absolute freshness on arrival.' },
  { title: 'Elite In-Store Care', desc: 'Warm, knowledgeable service that feels like family.' },
];

export const stores = [
  {
    id: 'pendle-hill',
    name: 'Pendle Hill Outlet',
    tag: 'FLAGSHIP',
    address: '124 Pendle Way, Pendle Hill NSW 2145',
    phone: '(02) 9636 9644',
    hours: 'Mon–Sun: 8:00 AM – 9:00 PM',
    mapUrl: 'https://maps.google.com/?q=124+Pendle+Way,+Pendle+Hill+NSW+2145',
    mapEmbed:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3314.2423377774134!2d150.95044457630245!3d-33.80604191711204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12a29fa0c444db%3A0xd994b86f74eb57dd!2s124%20Pendle%20Way%2C%20Pendle%20Hill%20NSW%202145!5e0!3m2!1sen!2sau!4v1710000000000!5m2!1sen!2sau',
    image: images.marketStall,
  },
  {
    id: 'marsden-park',
    name: 'Marsden Park Mega Store',
    tag: 'NEW FLAGSHIP OPENING',
    address: '861 Richmond Rd, Marsden Park NSW 2765',
    phone: '(02) 8605 9153',
    hours: 'Mon–Sun: 8:00 AM – 9:00 PM',
    mapUrl: 'https://maps.google.com/?q=861+Richmond+Rd,+Marsden+Park+NSW+2765',
    mapEmbed:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3318.2721867807753!2d150.835154576298!3d-33.70191831168434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12984b9f298587%3A0xf639ee8cb8fc0b!2s861%20Richmond%20Rd%2C%20Marsden%20Park%20NSW%202765!5e0!3m2!1sen!2sau!4v1710000000001!5m2!1sen!2sau',
    image: images.storeInterior,
  },
];

export const testimonials = [
  {
    name: 'Priya Nair',
    location: 'Parramatta, NSW',
    text: 'The freshest curry leaves and the best Sinthia chilli powder in Sydney. It genuinely tastes like home.',
  },
  {
    name: 'Rajan Kumar',
    location: 'Blacktown, NSW',
    text: 'Their basmati rice is naturally aged and aromatic. KST Spice Corner never disappoints on quality.',
  },
  {
    name: 'Anushka Fernando',
    location: 'Pendle Hill, NSW',
    text: 'Wonderful Sri Lankan staples I could not find anywhere else. The staff are so warm and helpful.',
  },
];

export const contactInfo = {
  email: 'info@spicecorner.com.au',
  marsden: '861 Richmond Rd, Marsden Park NSW 2765',
  pendle: '124 Pendle Way, Pendle Hill NSW 2145',
};
